import { useEffect } from 'react';

import { reportingFormsStore } from '@stores/reportingFormsStore';
import { reportingTreeStore } from '@stores/reportingTreeStore';

// Возможно можно будет убрать, так как не проваливания из отчета в отчет
export const useBgColorSelectNode = (): void => {
  const { pagesParam } = reportingFormsStore;
  const { stateTree } = reportingTreeStore;

  useEffect(() => {
    const selectNode = document.querySelector<HTMLElement>('[data-select-node]');
    if (selectNode) selectNode?.removeAttribute('data-select-node');

    if (pagesParam.length) {
      const { reportPackageCode, reportVersionCode } = pagesParam.at(-1) ?? {};

      const query = `[data-package="${reportPackageCode}"][data-version="${reportVersionCode}"]`;

      setTimeout(() => {
        const el = document.querySelector(query);

        if (el) {
          const row = el.closest<HTMLElement>('.ant-tree-treenode');
          if (row) row.setAttribute('data-select-node', ''); // добавляем атрибут, а не класс, потому что при открытие/закрытие узла проставляются классы antd и наш затерается
        }
      }, 350);
    }
  }, [pagesParam, stateTree.expandedKeys]);
};
